const mapServiceListFromApi = (
  api: ApiFetchStrategyListItem[]
): ServiceListItem[] => {
  return api.map((item) => ({
    id: item.id,
    title: item.intro.title,
    subtitle1: item.intro.subtitle1,
    subtitle2: item.intro.subtitle2,
    image: item.intro.image,
    backgroundColor: item.background_color,
  }));
};

export default mapServiceListFromApi;
